export default "__VITE_ASSET__Dob1xEnE__";